import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-penetration6070-page',
  templateUrl: './penetration6070-page.component.html',
  styleUrls: ['./penetration6070-page.component.scss']
})
export class Penetration6070PageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
